//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CharacteristicsList",

  props: {
    charString: {
      type: Object,
      default() {
        return {};
      }
    },
  },
}
